import React from 'react';
import '../App.css';
import Header from '../Components/Header'; // Use shared Header
import logo from '../assets/logo.png'; // Remove if Header already includes the logo

const Doctors = () => {
  return (
    <div className="doctors-page">
      {/* ✅ Shared Header (or fallback below) */}
      {Header ? <Header /> : (
        <header>
          <nav className="navbar">
            <a href="/" className="logo">
              <img src={logo} alt="Chaman Hospital" className="logo-img" />
            </a>
            <ul className="nav-links">
              <li><a href="/">Home</a></li>
              <li><a href="/appointment">Appointment</a></li>
              <li><a href="/services">Services</a></li>
              <li><a href="/doctors" className="active">Doctors</a></li>
              <li><a href="/about">About</a></li>
              <li><a href="/contact">Contact</a></li>
            </ul>
          </nav>
        </header>
      )}

      {/* Doctors Section */}
      <section className="doctors-section">
        <div className="container">
          <h2>Our Expert Doctors</h2>
          <p className="subtitle">Meet the highly qualified medical professionals who are dedicated to providing exceptional healthcare.</p>

          <div className="doctors-list">
            {[
              {
                name: 'Dr. Mandip Singh',
                qualification: 'MBBS, MD (Medicine)',
                description: 'Specialist in Internal Medicine with 10+ years of experience.'
              },
              {
                name: 'Dr. Rajeev Malhotra',
                qualification: 'MS (General Surgery)',
                description: 'Expert in laparoscopic and open surgical procedures.'
              },
              {
                name: 'Dr. Meenakshi Gupta',
                qualification: 'DCH, MD (Pediatrics)',
                description: 'Renowned child specialist ensuring best pediatric care.'
              },
              {
                name: 'Dr. A.K. Verma',
                qualification: 'DM (Cardiology)',
                description: 'Experienced cardiologist for all heart-related conditions.'
              },
              {
                name: 'Dr. Simran Kaur',
                qualification: 'MD (Gynecology)',
                description: 'Specialist in women’s health, maternity, and prenatal care.'
              },
              {
                name: 'Dr. Ravi Singh',
                qualification: 'Physiotherapist',
                description: 'Skilled in rehabilitation and pain management therapies.'
              }
            ].map((doc, index) => (
              <div key={index} className="doctor-card">
                <h3>{doc.name}</h3>
                <p><strong>{doc.qualification}</strong></p>
                <p>{doc.description}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Footer */}
      <footer>
        <div className="footer-content">
          <p>© {new Date().getFullYear()} Chaman Hospital. All Rights Reserved.</p>
        </div>
      </footer>
    </div>
  );
};

export default Doctors;
